<template>
  <div class="d-flex align-center flex-column pt-3">
    <div v-if="dataSet" class="_60_w">
      <title-page title="History Blast Email" class="mb-5" />
      <v-card
        class="pa-3 mb-3"
        flat
        v-for="(item, $index) in dataSet"
        :key="$index"
      >
        <p>{{ $date(item.createdAt).format("dddd, DD MMMM YYYY | HH:mm") }}</p>
        <v-row>
          <v-col cols="6">
            <v-card color="#E3F2FD" class="pa-2" flat>
              Sent : <b>{{ item.success }}</b>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card color="#FFCDD2" class="pa-2" flat>
              Failed : <b>{{ item.failed }}</b>
            </v-card>
          </v-col>
        </v-row>
        <v-card outlined class="pa-2 mt-3" v-if="item.failedTo.length">
          <div>
            <b> Email not sent to</b>
          </div>
          <v-chip
            v-for="(email, i) in item.failedTo"
            :key="`vendor-${i}`"
            class="ma-1"
          >
            {{ email }}
          </v-chip>
        </v-card>
      </v-card>
      <infinite-loading
        :identifier="infiniteId"
        spinner="waveDots"
        @infinite="fetchData"
      >
        <div slot="no-more"></div>
        <div slot="no-results">No results</div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import titlePage from "../../components/atom/titlePage.vue";
export default {
  components: { titlePage },
  name: "historyBlast",
  data() {
    return {
      dataSet: [],
      page: 1,
      limit: 10,
      infiniteId: +new Date(),
    };
  },
  methods: {
    fetchData($state) {
      this.loading = true;

      let data = {
        path: `mail/blast/progress?&page=${this.page}&perPage=${this.limit}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then(({ data }) => {
          if (data.length) {
            this.page += 1;
            this.dataSet.push(...data);
            $state.loaded();
          } else {
            $state.complete();
          }
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
  },
};
</script>

<style>
</style>